class AdCanvas {

    constructor($rootScope, $builderService, $timeout) {

        this.$rootScope = $rootScope;
        this.$builderService = $builderService;
        this.$timeout = $timeout;

        this.copyLayerProps = {
            name: true,
            src: true,
            contentType: true,
            contentLength: true,
            width: true,
            height: true,
            encodings: true,
            acceptCanvas: true
        };
        
        return {
            restrict: 'E',
            scope: {
                "adunit": "=",
            	"canvas": "=",
                "selectedEntity": "="
            },
            link: ($scope, $el, $attr) => {

                
                let contentWidth = angular.element('.content').width();
                let contentHeight = angular.element(window).height();
                
            	$el.css({
                    top: $scope.canvas.top,
                    left: $scope.canvas.left,
            		width: $scope.canvas.width,
            		height: $scope.canvas.height,
            	});
                
                this.calcuateBodyCss($scope, $el);

                $el.mousedown( (ev) => {
                    if(!$scope.canvas.selected) {
                        ev.stopPropagation();
                        $scope.$emit("select-canvas", $scope.canvas);
                        this.$rootScope.$emit("select-canvas", $scope.canvas);
                        $scope.$apply();
                    }
                });


            	$el.droppable({
                    tolerance: "pointer",
                    greedy: true,
            		accept: (draggable) => {            			
            			let widget = $(draggable).data("reflow-asset");
                        let isLocked = "undefined" != typeof $scope.canvas.locked && $scope.canvas.locked
            			return (!!widget) ? widget.contentType !== 'x-reflow/canvas' && !isLocked  : false;
            		},
            		over: (ev, ui) => {
                        $rootScope.pushDroppable($el);
            		},
            		out: (ev, ui) => {
                        $rootScope.popDroppable();
            		},
            		drop: (ev, ui) => {
                        if(ui.helper.is(".dropped")) {
                            return false;
                        }
                        ui.helper.addClass("dropped");
                        let widget = $(ui.draggable).data("reflow-asset");
                        if(widget.contentType.startsWith("x-reflow")) {
                            widget = this.$builderService.findWidget(widget.contentType);
                        }
                        let offset = $el.offset();
            			this.handleDrop.call(this, $scope, $scope.canvas, widget, { top: ui.offset.top - offset.top, left: ui.offset.left - offset.left });
            			$scope.$apply();
            		}
            	});

                $(".canvas-title", $el).draggable({
                    helper: "clone",
                    appendTo: ".workspace",
                    cursorAt: { top: 5, left: 5 }, 
                    drag: (ev, ui) => {
                        let parentOffset = $el.parent().offset();
                        $scope.canvas.top = ui.offset.top - parentOffset.top + 21;
                        $scope.canvas.left = ui.offset.left - parentOffset.left;
                        $(".canvas-title", $el).css({top: "-21px", left: "0px"});
                        $scope.$apply();
                    }
                });

            	$(".ad-canvas-body", $el).mousedown( (ev) => {
            		if(ev.target == $el.get(0)) {
	            		$scope.$emit("select-canvas", $scope.canvas);
                        this.$rootScope.$emit("select-canvas", $scope.canvas);
	            	}
            	});

                $(".canvas-title", $el).mousedown( (ev) => {
                    $scope.$emit("select-canvas", $scope.canvas);
                });

            	$scope.$watch("selectedEntity", (updated) => {
                    $scope.canvas.selected = false;
                    if(!!updated && !!$scope.canvas) {
                        if($scope.canvas.id === updated.id && $scope.canvas.contentType === updated.contentType) {
                            $el.addClass("selected");
                            $scope.canvas.selected = true;
                        }
                        else {
                            $el.removeClass("selected");
                        }
                    }
                    else {
                        $el.removeClass("selected");
                    }
            	});



                $scope.$watch("canvas", (newval, oldval) => {

                    var shouldUpdate = false;
                    if(!oldval) {
                        shouldUpdate = true;
                    } else {
                        shouldUpdate = newval.top != oldval.top || newval.left != oldval.left || newval.width != oldval.width || newval.height != oldval.height || newval.visibleInDesigner != oldval.visibleInDesigner;
                    }
                    
                    if(shouldUpdate) {
                        $el.css({
                            top: newval.top,
                            left: newval.left,
                            width: newval.width,
                            height: newval.height,
                            display: (!!newval.visibleInDesigner ? "block" : "none")
                        });
                        this.calcuateBodyCss($scope, $el);
                        $rootScope.$broadcast("render");
                    }
                    
                }, true);
            }

        };

    }

    calcuateBodyCss($scope, $el) {

        let css = {};

        if(!!$scope.canvas.colour) {
            css.color = $scope.canvas.colour;
        }

        if(!!$scope.canvas.padding) {
            css.padding = $scope.canvas.padding + "px";
        }

        if(!!$scope.canvas.backgroundColour) {
            css["background-color"] = $scope.canvas.backgroundColour;
        }

        if(!!$scope.canvas.borderStyle) {
            
            var border = "";
            if(!!$scope.canvas.borderWidth) {
                if(/^\d+$/.test($scope.canvas.borderWidth)) {
                    border += $scope.canvas.borderWidth + "px";
                }
                else {
                    border += $scope.canvas.borderWidth;
                }
            }
            else {
                border += "1px";
            }

            border += " " + $scope.canvas.borderStyle;
            
            if(!!$scope.canvas.borderColour) {
                border += " " + $scope.canvas.borderColour;
            }
            else {
                border += " black";
            }

            css.border = border;

        }
        else {
            css.border = "none";
        }

        $(".ad-canvas-body", $el).css(css);

    }

    handleDrop($scope, canvas, asset, pos) {

        this.$rootScope.$emit("adding-layer", true);
    	
        var layer = {
    		id: ObjectId(),
            contentType: "x-reflow/layer",
            assetId: asset._id,
            name: asset.name,
    		top: pos.top,
    		left: pos.left,
            visible: true,
            visibleInDesigner: true,
            templateVars: { src: null },
            behaviours: [],
            maintainAspectRatio: asset.contentType.startsWith("image") || asset.contentType.startsWith("video"),
            scaling: asset.contentType.startsWith("image") ? "fit" : "clip",
            colour: "#000000",
            opacity: 1,
            borderStyle: '',
            backgroundColour: '',
            padding: null,
            borderWidth: null,
            borderRadius: null,
            borderColour: ''
    	};

        if(!!asset.subType) {
            if(asset.subType == 'text') {
                layer.textVerticleAlign = 'top';
                layer.textTransform = 'none';
                layer.textDirection = 'ltr';
                layer.fontFamily = 'Arial';
                layer.bold = false;
                layer.italic = false;
                layer.decoration = 'none'
                layer.textDirection = null;
            }
        }

        let isContained = false;
        Object.keys($scope.adunit.deviceroots).forEach(deviceRoot => {
            if($scope.adunit.deviceroots[deviceRoot] == canvas.id) {
                isContained = true;
            }
        });

        if(asset.contentType.startsWith("video/") && !isContained) {
            layer.videoTracking = true;
        }
    	
        if(!!asset.width && !!asset.height) {
            layer.width = asset.width;
            layer.height = asset.height;
        }

        $scope.adunit.assets[asset._id] = asset;

        if("function" === typeof asset.init) {
            asset.init(layer);
        }

        canvas.layers.unshift(layer);
        
        $scope.$evalAsync( () => {
            this.$rootScope.$emit("select-layer", layer);
        });

        this.$timeout(() => {
            // console.log()
            this.$rootScope.$emit("adding-layer", false);
        }, 0);

    }

}

angular.module('cpm')
    .directive('adCanvasDesigner', ["$rootScope", "$builderService", "$timeout", ($rootScope, $builderService, $timeout) => {
        'use strict';
        return new AdCanvas($rootScope, $builderService, $timeout);
    }]);
